<div class="mb-2" style="position: relative">
  <div class="text-end mb-2" *ngIf="!isReadOnly">
    <button
      type="button"
      class="btn btn-sm btn-primary btn-icon-xxs ms-2"
      (click)="icdList()"
    >
      <i class="fas fa-book-open"></i>
    </button>
    <button
      type="button"
      class="btn btn-sm btn-warning btn-icon-xxs ms-2"
      (click)="newHeadItem()"
    >
      <i class="fas fa-add"></i>
    </button>
  </div>
  <div *ngIf="newMedicalRecordItem">
    <div class="search-container mb-2">
      
      <!-- [icdCodes]="icdCodes" -->
      <app-icd-code-dropdown
        (changeOn)="onIcdDropdownChange($event)"
        #icdCodeDropdown
      >
      </app-icd-code-dropdown>
    </div>
    <div>
      <textarea
        class="form-control"
        placeholder="{{ 'general.description' | translate }}"
        [(ngModel)]="newMedicalRecordData.description"
        [attr.maxlength]="255"
      ></textarea>
      <div class="text-end text-muted small">
        {{ currentLength }} / {{ 255 }}
      </div>
    </div>
    <div class="mt-2 d-flex justify-content-end">
      <button class="btn btn-sm btn-primary" (click)="add()">
        {{ "general.add" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="cards">
  <div
    *ngFor="let item of medicalRecordItems; let i = index; trackBy: trackByFn"
  >
    <div *ngIf="!showType || showType === item?.savedType" class="card-item">
      <ng-container *ngIf="editingIndex !== i; else editingRow">
        <div
          class="card-title"
          (mouseenter)="showTooltip(i, $event)"
          (mouseleave)="hideTooltip()"
        >
          {{ item?.icdCode }} {{ item?.icdCodeName }}
        </div>
        <div class="card-description">{{ item?.description }}</div>
        <div class="card-actions" *ngIf="!isReadOnly">
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs me-1"
            (click)="edit(item, i)"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger btn-icon-xxs"
            (click)="deleteItem(i)"
          >
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </ng-container>
      <ng-template #editingRow>
        <div>
          
          <!-- [icdCodes]="icdCodes" -->
          <app-icd-code-dropdown
            #icdCodeDropdownEdit
            (changeOn)="onSelectedIcdDropdownChange($event)"
          >
          </app-icd-code-dropdown>
        </div>
        <div class="card-description">
          <textarea
            class="form-control"
            placeholder="{{ 'general.description' | translate }}"
            [(ngModel)]="selectedRow.description"
            [attr.maxlength]="255"
          ></textarea>
          <div class="text-end text-muted small">
            {{ editedCurrentLength }} / {{ 255 }}
          </div>
        </div>
        <div class="card-actions" *ngIf="!isReadOnly">
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs me-1"
            (click)="saveItem()"
            [disabled]="!selectedRow.icd && !selectedRow.description"
          >
            <i class="fas fa-save"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger btn-icon-xxs"
            (click)="cancel()"
          >
            <i class="fas fa-close"></i>
          </button>
        </div>
      </ng-template>
      <div
        class="tooltip-content"
        *ngIf="activeTooltipIndex !== null"
        [style.top.px]="tooltipPosition.y"
        [style.left.px]="tooltipPosition.x"
      >
        <div *ngIf="medicalRecordItems[activeTooltipIndex]?.icdCode">
          {{ medicalRecordItems[activeTooltipIndex]?.icdCode }}
          {{ medicalRecordItems[activeTooltipIndex]?.icdCodeName }}<br />
        </div>
      </div>
    </div>
  </div>
</div>

<app-icd-codes-popup
  (saveOn)="handlePopupData($event)"
  #icdCodePopup
></app-icd-codes-popup>
